import { render, staticRenderFns } from "./TilesMenu.vue?vue&type=template&id=9a5729ba&scoped=true"
import script from "./TilesMenu.vue?vue&type=script&lang=js"
export * from "./TilesMenu.vue?vue&type=script&lang=js"
import style0 from "./TilesMenu.vue?vue&type=style&index=0&id=9a5729ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5729ba",
  null
  
)

export default component.exports